/* Core & libraries */
import React, { useState, useRef, useEffect } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UCButton from "../../../buttons";

/* Helpers, constants, custom methods, internal libraries */
import {usePeopleService} from "../../../../services/peopleService";

/* Components */

/* Styles */
import styles from "./styles.js"
import {colors} from "../../../../constants/colors";


const VerifyEmail = props => {
  const { setShowModal, enteredEmail, travelerDetails } = props;

  const initialCode = {
    digit1: '',
    digit2: '',
    digit3: '',
    digit4: '',
  };

  const theme = useTheme();
  const classes = styles({ theme });

  const { updateUserEmail, resendEmailCode } = usePeopleService()

  const [code, setCode] = useState(initialCode);
  const [isDisabled, setIsDisabled] = useState(true);
  const [fullCode, setfullCode] = useState('');
  const [error, setError] = useState(false);
  const [expiredError, setExpiredError] = useState(false);
  const [incorrectError, setIncorrectError] = useState(false);
  const [tooManyError, setTooManyError] = useState(false);
  const [newResetText, setNewResetText] = useState(false)

  useEffect(() => {
    setfullCode(Object.values(code).join(''));
  }, [code]);

  useEffect(() => {
    setIsDisabled(fullCode?.length !== 4);
  }, [fullCode]);

  const handleResetCode = () => {
    resendEmailCode();
    setNewResetText(true);
    setCode(initialCode);
    document.getElementById('digit2').parentElement.classList.remove('active');
    document.getElementById('digit3').parentElement.classList.remove('active');
    document.getElementById('digit4').parentElement.classList.remove('active');
    document.getElementById('digit1').focus();
    setError(false);
    setExpiredError(false);
    setIncorrectError(false);
    setTooManyError(false)
  };

  const handleChangeEmail = async (fullCode) => {
    const updateEmailResponse = await updateUserEmail({
      emailAddress: enteredEmail,
      userId: travelerDetails?.userEntityId,
      roleId: "",
      groupEntityId: "",
      marketingNewsAndOffers: "",
      marketingBusinessSummary:"" ,
      marketingPromotions: "",
      isTripLinkAccount: "",
      verificationCode: fullCode
    })
    if (updateEmailResponse.status === "ERROR") {
      const errorCode = updateEmailResponse?.errors[0]?.errorCode;
      if ( errorCode === '7001' ) {
        setError(true)
      } else if ( errorCode === '7002' ) {
        setExpiredError(true)
      } else if ( errorCode === '7003' ) {
        setIncorrectError(true)
      }else if ( errorCode === '7004' ) {
        setTooManyError(true)
      }
    } else if (updateEmailResponse.status === "SUCCESS") {
      setShowModal(false)
      window.location.reload()
    }
  }

  const handleKeyUp = (e, identifier) => {
    setError(false);
    setExpiredError(false);
    setIncorrectError(false);
    setTooManyError(false)
    switch (e.keyCode) {
      //backspace
      case 8:
        if (code[identifier] === '') {
          const prev = Object.keys(code).findIndex(
            (item) => item === identifier
          );
          const toFocus = document.getElementById('digit' + prev);
          const nextElem = document.getElementById('digit' + (prev + 1));
          if (prev > 0) {
            setCode({
              ...code,
              ['digit' + prev]: '',
            });
            nextElem.parentElement.classList.remove('active');
            toFocus.focus();
          }
        } else {
          const current =
            Object.keys(code).findIndex((item) => item === identifier) + 1;
          setCode({
            ...code,
            ['digit' + current]: '',
          });
        }
        break;

      default:
        if (e.key.match(/[0-9]/g)) {
          setCode({
            ...code,
            [identifier]: e.key,
          });
          // focus next input
          const current =
            Object.keys(code).findIndex((item) => item === identifier) + 1;
          const toFocus = document.getElementById('digit' + (current + 1));
          if (current + 1 < 5 && e.key !== '') {
            toFocus.focus();
            toFocus.parentElement.classList.add('active');
          }
          if (current === 4) {
            document.getElementById('digit4').blur();
          }
        }
    }
  };

  const handlePaste = (e) => {
    const pastedData = e.clipboardData.getData('Text')
    if (/^\d{1,4}$/.test(pastedData)) {
      const keys = Object.keys(code);
      const updatedCode = { ...code };

      for (let i = 0; i < pastedData.length; i++) {
        const key = keys[i];
        updatedCode[key] = pastedData[i];

        const element = document.getElementById(key);
        if (element) {
          element.value = pastedData[i];
          element.parentElement.classList.add("active");
        }
      }

      setCode(updatedCode); 

      if (pastedData.length < 4) {
        const toFocus = document.getElementById("digit" + (pastedData.length + 1))
        toFocus.focus()
        toFocus.parentElement.classList.add("active");
      }

      if (pastedData.length === 4) {
        document.getElementById("digit1").blur();
      }
    } else return

  }

  const handleFocus = (e) => {
    document.querySelectorAll(`.${classes.digit}`).forEach(el =>
      el.classList.remove("active")
    );
    e.target.parentElement.classList.add("active");
  };

  return (
    <div className={classes.verifyEmail}>
      <div>
        <div className={classes.content}>
          <div className={classes.digits}>
            <div className={`${classes.digit} col active`}>
              <input
                autoFocus
                placeholder={"0"}
                autoComplete='off'
                name='searchTerm'
                id={'digit1'}
                onPaste={(e) => handlePaste(e)}
                onKeyUp={(e) => handleKeyUp(e, 'digit1')}
                onFocus={handleFocus}
                type='number'
                onInput={(e) => (e.target.value = e.target.value.slice(0, 1))}
                value={code.digit1}
              />
            </div>
            <div className={`${classes.digit} col`}>
              <input
                autoComplete='off'
                placeholder={"0"}
                name='searchTerm'
                id={'digit2'}
                onPaste={(e) => handlePaste(e)}
                onKeyUp={(e) => handleKeyUp(e, 'digit2')}
                onFocus={handleFocus}
                type='number'
                onInput={(e) => (e.target.value = e.target.value.slice(0, 1))}
                value={code.digit2}
              />
            </div>
            <div className={`${classes.digit} col`}>
              <input
                autoComplete='off'
                placeholder={"0"}
                name='searchTerm'
                id={'digit3'}
                onPaste={(e) => handlePaste(e)}
                onKeyUp={(e) => handleKeyUp(e, 'digit3')}
                onFocus={handleFocus}
                type='number'
                onInput={(e) => (e.target.value = e.target.value.slice(0, 1))}
                value={code.digit3}
              />
            </div>
            <div className={`${classes.digit} col`}>
              <input
                autoComplete='off'
                placeholder={"0"}
                name='searchTerm'
                id={'digit4'}
                onPaste={(e) => handlePaste(e)}
                onKeyUp={(e) => handleKeyUp(e, 'digit4')}
                onFocus={handleFocus}
                type='number'
                onInput={(e) => (e.target.value = e.target.value.slice(0, 1))}
                value={code.digit4}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={classes.didntReceive}>
        {error && (
          <div className={classes.emailError}>
            <FormattedMessage id='updateEmailModal.codeVerificationError' />
          </div>
        )}
        {expiredError && (
          <div className={classes.emailError}>
            <FormattedMessage id='updateEmailModal.codeExpiredError' />
          </div>
        )}
        {incorrectError && (
          <div className={classes.emailError}>
            <FormattedMessage id='updateEmailModal.codeIncorrectError' />
          </div>
        )}
        {tooManyError && (
          <div className={classes.emailError}>
            <FormattedMessage id='updateEmailModal.codeTooManyError' />
          </div>
        )}
        {newResetText ? (
          <div>
            <FormattedMessage id='check.newCodeText'/>
          </div>
        ) : (
          <div>
            <FormattedMessage id='check.didntReceive'/>
            <button className={classes.resendBtn} onClick={handleResetCode}>
              <FormattedMessage id='check.resendTxt'/>
            </button>
          </div>
        )}
      </div>
      <div className={classes.btnContainer}>
        <ContainerFluid>
          <Row>
            <Col className={classes.colCancel}>
              <UCButton
                onClick={() => setShowModal(false)}
                type="default"
                className={classes.cancelBtn}
                text={<FormattedMessage id="updateEmailModal.cancel"/>}
              />
            </Col>
            <Col className={classes.colRemove}>
              <UCButton
                className={classes.createBtn}
                onClick={() => handleChangeEmail(fullCode, enteredEmail)}
                type="primary"
                disabled={ isDisabled  }
                text={<FormattedMessage id="updateEmailModal.verifyBtn"/>}
                spinner={{
                  name: "updateEmailSpinner",
                  size: 20,
                  color: colors.white
                }}
              />
            </Col>
          </Row>
        </ContainerFluid>
      </div>
    </div>
  )
}

export default VerifyEmail;
